"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PruebasService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class PruebasService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.getPruebas = async (id, isWeb = false) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/requests/centraltest/${id}?isWeb=${isWeb}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postCreateCentralTest = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/requests/centraltest`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response) : Promise.reject(response);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.PruebasService = PruebasService;
